/**
 * OrderListPresenter
 * --
 */
import { useEffect, useState } from 'react';
import { Content, Title, Row, Col, ModalLayout, Statement } from 'components';
import { Button, Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import OrderFilter from './components/OrderFilter';
import OrderSummaryStatics from './components/OrderSummaryStatics';
import OrderDetail from './components/OrderDetail';
import OrderData from './components/OrderData';
import RegularDetail from '../RegularList2/components/RegularDetail';
import refineStatement from 'utils/refineStatement';

/**----------------------------------------
 * [Component] 주문내역 - 프레젠터
 * -----------------------FloatButton-----------------
 */
const OrderListPresenter = ({
  permission,
  loading,
  orderList,
  searchFilter,
  handleChange,
  getOrders,
  onResetFilter,
  currentShop,
  setCurrentShop,
  onCancel,
  order_type,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isModalVisible, setIsModalVisible] = useState(null);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== VARIABLES ===== */
  // 결제완료 데이터
  const completedData = orderList.filter(
    (o) => o.payment_state === 'COMPLETED',
  );
  // 환불/취소 데이터
  const refundedList = orderList.filter((o) =>
    ['PARTIALLY_REFUNDED', 'REFUNDED'].includes(o.payment_state),
  );
  const refundedData = refundedList.flatMap((order) => {
    return order.parcel_service
      ?.flatMap((parcel) => {
        //환불 있는지
        if (!parcel?.refund) return null;
        //있으면 추출
        const refund = parcel?.refund?.at(-1);
        //완료 상태 인지
        // 실제 환불이 완료된 건만 환불 집계에 포함합니다.
        if (refund?.refund_status !== 'COMPLETED') return null;
        return refund;
      })
      .filter(Boolean);
  });
  const refundCount = refundedData.length ?? 0;
  //NOTE: 환불 금액
  const refundPrice =
    refundedData?.reduce((acc, cur) => acc + (cur?.refund_amount ?? 0), 0) ?? 0;
  const totalCount = orderList.length ?? 0;
  //NOTE: 전체 결제 금액(할인금 제외/환불금 포함)
  const totalPrice =
    orderList.reduce(
      (acc, cur) =>
        cur.payment_completion_date ? acc + (cur.final_price ?? 0) : acc,
      0,
    ) ?? 0;
  //NOTE: 할인금액
  const totalDiscount =
    completedData.reduce(
      (acc, cur) => acc + (cur.final_discount ?? 0) + (cur?.use_point ?? 0),
      0,
    ) ?? 0;
  /**
   *
   * --
   */
  const getTitle = () => {
    switch (order_type) {
      case 'PREPARING':
        return '상품 준비중';
      case 'ON_HOLD':
        return '배송보류';
      case 'SHIPPING':
        return '배송중';
      case 'DELIVERED':
        return '배송완료';
      case 'EXCHANGE_REQUESTED':
      case 'EXCHANGE_COMPLETED':
      case 'RETURN_REQUESTED':
      case 'RETURN_COMPLETED':
      case 'RETURN':
        return '취소/교환/반품/환불';
      default:
        return '주문 목록';
    }
  };

  const initialProps = {
    orderNo: null,
    orderDate: null,
    orderList: null,
    cancelList: null,
    exchangeList: null,
    returnList: null,
    refundList: null,
    paymentInfo: {},
    ordererInfo: {},
    recipientInfo: {},
  };
  const [statementOpen, setStatementOpen] = useState(false);
  const [statementProps, setStatementProps] = useState(initialProps);
  const openStatement = () => {
    const refineData = refineStatement(isModalVisible);
    setStatementProps(refineData);

    setStatementOpen(!statementOpen);
  };

  useEffect(() => {
    if (isModalVisible) {
      const foundOrder = orderList.find(
        (o) => o.shop_order_id === isModalVisible?.shop_order_id,
      );
      setIsModalVisible(foundOrder);
    }
  }, [orderList]);
  /* ===== RENDER ===== */
  // console.log('[OrderListPresenter] orderList: ', orderList);

  return (
    <>
      <Spin spinning={loading} indicator={<LoadingOutlined spin />}>
        <Row>
          <Col x={24}>
            <Content
              maxWidth={'100%'}
              borderRadius={4}
              padding={20}
              backgroundColor={'none'}
            >
              <Title size={3} style={{ marginBottom: 10 }}>
                {getTitle()}
              </Title>
              {/* === 검색필터 컴포넌트=== */}
              <OrderFilter
                searchFilter={searchFilter}
                handleChange={handleChange}
                getOrders={getOrders}
                onResetFilter={onResetFilter}
                defaultShop={permission === 'ADMIN' ? null : currentShop}
                onSelect={setCurrentShop}
                permission={permission}
              />
              {/* === 요약 === */}
              <OrderSummaryStatics
                totalCount={totalCount}
                totalPrice={totalPrice}
                totalDiscount={totalDiscount}
                refundPrice={refundPrice}
                refundCount={refundCount}
              />

              <Row style={{ minHeight: '50vh' }} className="boxShadow">
                {/* === 업체목록 === */}
                {/* {permission === 'ADMIN' && (
                  <Col x={3}>
                    <ShopInformationList
                      onChange={setCurrentShop}
                      defaultChoose
                    />
                  </Col>
                )} */}
                {/* === Data === */}
                <Col
                  // x={permission === 'ADMIN' ? 21 : 24}
                  x={24}
                  style={{
                    borderLeft: '1px solid #EBEBEB',
                    backgroundColor: '#fff',
                  }}
                >
                  <OrderData
                    orderList={orderList}
                    setIsModalVisible={setIsModalVisible}
                    type={order_type}
                    onReload={getOrders}
                  />
                </Col>
              </Row>

              {/* ===== 상세모달 ===== */}
              <ModalLayout
                type="drawer"
                maxWidth={960}
                isOpen={isModalVisible !== null}
                open={isModalVisible !== null}
                title="주문 상세보기"
                closable={true}
                onCancel={() => setIsModalVisible(null)}
                extra={
                  isModalVisible && isModalVisible?.type !== 'SUBSCRIPTION' ? (
                    <Flex gap={8}>
                      <Button type="primary" onClick={() => openStatement()}>
                        명세서 출력
                      </Button>
                    </Flex>
                  ) : null
                }
              >
                {isModalVisible ? (
                  isModalVisible?.type !== 'SUBSCRIPTION' ? (
                    <OrderDetail
                      orderId={isModalVisible.shop_order_id}
                      isModalVisible={isModalVisible}
                      onCancel={onCancel}
                      type={order_type}
                      onReload={getOrders}
                    />
                  ) : (
                    <RegularDetail
                      orderDetailData={{
                        key: isModalVisible?.parcel_service_id,
                        ...isModalVisible?.parcel_service?.[0],
                        shop_order: isModalVisible,
                        user: isModalVisible?.user,
                        shop_information: isModalVisible?.shop_information,
                      }}
                      type={'order'}
                      onCancel={onCancel}
                      onReload={getOrders}
                    />
                  )
                ) : null}
                {/* <OrderDetail isModalVisible={isModalVisible} /> */}
              </ModalLayout>
            </Content>
          </Col>
        </Row>
      </Spin>

      <ModalLayout
        open={statementOpen}
        onCancel={() => setStatementOpen(!statementOpen)}
        width={1000}
        height={1414}
      >
        <Statement {...statementProps} />
      </ModalLayout>
    </>
  );
};

export default OrderListPresenter;
